import { API_CARD_ROOT_ENDPOINT } from "./constants"
import { api } from "../api"
import { convertObjectKeysToCamelCase } from "../../utils/helpers"

export const getOrganizations = async (Token) => {
    try {
        const res = await api.post(`/User/get_organizations`, Token)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
        //throw err
    }
}

export const getResellers = async (selector) => {
    try {
        const res = await api.post(`/User/get_resellers`, selector)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
       // throw err
    }
}

export const createNewAccount = async (newUser) => {
    try {
        const res = await api.post(`/User/create_user`, newUser)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
       // throw err
    }
}

export const createNewOrganization = async (newOrg) => {
    try {
        const res = await api.post(`/User/create_organization`, newOrg)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
        // throw err
    }
}

export const getStrayCards = async (Token) => {
    try {
        const res = await api.post(`/Card/fetch_stray_cards`, Token)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
        // throw err
    }
}

export const connectCard = async (cardConnector) => {
    try {
        const res = await api.post(`/Card/connect_card`, cardConnector)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
        // throw err
    }
}

export const getAccounts = async (token) => {
    try {
        const res = await api.post(`/User/fetch_accounts`, token)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

        const data = await res.json()
        return data
    } catch (err) {
        // throw err
    }
}

export const removeOrganization = async (selector) => {
    try {
        const res = await api.post(`/User/delete_organization`, selector)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

    } catch (err) {
        // throw err
    }
}

export const removeAccount = async (selector) => {
    try {
        const res = await api.post(`/User/delete_account`, selector)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
    } catch (err) {
        // throw err
    }
}

export const fetchSingleAccount = async (selector) => {
    try {
        const res = await api.post(`/User/fetch_single_account`, selector)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status

            const data = await res.json()
            return data
    } catch (err) {
        // throw err
    }
}

export const editAccount = async (selector) => {
    try {
        const res = await api.post(`/User/edit_account`, selector)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
    } catch (err) {
        // throw err
    }
}

export const registerPushNotification = async (container) => {
    try {
        const res = await api.post(`/User/push_subscribe_user`, container)

        if (!res.ok)// { res.text().then(text => { throw new Error(`Error: ${text}`) }) }
            return res.status
    } catch (err) {
        // throw err
    }
}